<svg
  width="33"
  height="34"
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_3_366)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.5 17C29.5 24.1797 23.6797 30 16.5 30C9.3203 30 3.5 24.1797 3.5 17C3.5 9.8203 9.3203 4 16.5 4C23.6797 4 29.5 9.8203 29.5 17ZM16.5 33.5C25.6127 33.5 33 26.1127 33 17C33 7.8873 25.6127 0.5 16.5 0.5C7.3873 0.5 0 7.8873 0 17C0 26.1127 7.3873 33.5 16.5 33.5Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_3_366">
      <rect width="33" height="33" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
